import { useQuery } from '@tanstack/react-query';
import { parkedTaskService, type ListParkedTasksResult } from '../services/parkedTask.service';

export function useParkedTasks() {
  return useQuery<ListParkedTasksResult>({
    queryKey: ['parked-tasks'],
    queryFn: () => parkedTaskService.list(),
    staleTime: 15_000,
  });
}
